@if (elementInstance.visible$ | async) {
    <hb-felt [control]="form">
        <label
            class="hb-label-text si-semibol"
            translate
        >
            {{ elementInstance.opplastingLabel$ | async | translate }}
            <span class="hb-text--regular">{{elementInstance.uischema.isRequired() || (elementInstance.required$ | async) ? '' : ('(valgfritt)' | translate)}}</span>
        </label>
        <p class="rzr-felt-beskrivelse">{{ elementInstance.fieldDescription$ | async }}</p>
        @if (elementInstance.kravDetaljListe$) {
            <ul class="hb-list hb-list--gap-sm hb-mb--lg hb-text--secondary">
                @for (item of elementInstance.kravDetaljListe$ | async; track item) {
                    <li>{{ item | translate }}</li>
                }
            </ul>
        }
        <div class="hb-panel hb-panel--noytral rzr-drop-zone rzr-upload--desktop hb-my--lg"
             [class.rzr-drop-zone--active]="isDragOver()"
             (dragover)="onDragOver($event)"
             (dragleave)="onDragLeave($event)"
             (drop)="onDrop($event)"
        >
            @if (isDragOver()) {
                <div class="rzr-drop-zone--drag">
                    <div class="hb-mt--lg">
                        <p translate>Slipp for å laste opp</p>
                    </div>
                </div>
            } @else {
                <div>
                    <div class="hb-mb--md">
                        <p class="hb-mb--none" translate>Dra og slipp filer her</p>
                        <p class="hb-mt--sm hb-mb--md" translate>eller</p>
                    </div>
                    <div class="hb-pb--none">
                        <button hb-button class="hb-button--s"
                                (click)="onClickFileInput(fileInput)">
                            <span aria-hidden="true" [attr.data-e2e-selector]="elementInstance.propsPath+'-velgfiler'"
                                  translate>Velg filer</span>
                            <span class="hb-screenreader-only">{{ elementInstance.opplastingLabel$ | async | translate }}</span>
                        </button>
                    </div>
                </div>

            }
            <input type="file" (change)="onFileSelect($event)" [accept]="visKunGodkjenteTyper"
                   [attr.data-e2e-selector]="elementInstance.propsPath+'-filinput'" hidden multiple #fileInput/>
        </div>
        <div class="rzr-upload--mobile">
            <div class="hb-mt--lg hb-pb--lg">
                <button hb-button class="hb-button--s" iconId="upload-bottom" (click)="onClickFileInput(fileInput)">
                    <span aria-hidden="true" translate>Last opp filer</span>
                    <span class="hb-screenreader-only">{{ elementInstance.opplastingLabel$ | async | translate }}</span>
                </button>
            </div>
        </div>
        <div [attr.data-e2e-selector]="elementInstance.propsPath+'-filliste'">
            @if (fileVedleggData().length > 0) {
                <div>
                    <h3 class="hb-text--regular hb-text--base hb-mb--none hb-pt--xs">
                        Filer ({{ fileVedleggData().length }})
                    </h3>
                    <ul class="hb-p--none hb-mb--none">
                        @for (vedlegg of fileVedleggData(); track vedlegg.id) {
                            <li class="hb-panel hb-panel--hvit hb-my--sm hb-py--md">
                                <div class="rzr-display-flex rzr-display-flex--gap rzr-display-flex--align-center">
                                    @if (isLoading()[vedlegg.id]) {
                                        <div class="hb-spinner hb-spinner--tekst-justert hb-spinner--medium rzr-display-flex--no-shrink"></div>
                                    } @else {
                                        <hb-icon class="rzr-display-flex--no-shrink"
                                                 customIconUrl="/assets/images/custom.sprite.svg"
                                                 iconId="hb-file"/>
                                    }
                                    <div class="hb-ml--xs rzr-text-ellipsis">
                                        <a [title]="vedlegg.filnavn">{{ vedlegg.filnavn }}</a>
                                        <p class="hb-mb--none hb-text--sm hb-text--secondary">{{ vedlegg.stoerellse }}</p>
                                    </div>
                                    <div class="delete">
                                        <button hb-button
                                                (click)="velgForSletting(vedlegg)"
                                                variant="SUBTLE"
                                                [iconOnly]="true"
                                                iconId="bin-1"
                                                iconSize="Size200">
                                            <span class="hb-screenreader-only">Slett {{ vedlegg.filnavn }}</span>
                                        </button>
                                    </div>
                                </div>
                            </li>
                        }
                    </ul>
                </div>
            }
            @if (opplastingfeiletMelding(); as feilmelding) {
                <hb-callout tone="DESTRUCTIVE" [showCloseButton]="true" (closed)="lukkOpplastingFeilmelding()">{{ feilmelding }}</hb-callout>
            }
        </div>
    </hb-felt>
}

<hb-modal [visModal$]="visModal$">
    <div title class="hb-text--regular">{{ 'Er du sikker på at du vil slette "' | translate }}{{ selectedVedleggForDeletion()?.filnavn }}"?</div>
    <div footer>
        <hb-buttongroup>
            <button hb-button
                    [id]="'confirm-modal-confirm-btn'"
                    [variant]="'PROMINENT_DESTRUCTIVE'"
                    (click)="slett(selectedVedleggForDeletion())">
                <span translate>Ja, slett filen</span>
            </button>
            <button hb-button
                    [id]="'confirm-modal-discard-btn'"
                    [variant]="'STANDARD'"
                    (click)="avbrytSlett()">
                <span translate>Nei, avbryt</span>
            </button>
        </hb-buttongroup>
    </div>
</hb-modal>

